import { nowPaymentsSlug, PaymentTypes, PaymentTypesType } from '@bcraft-frontend-lib/payments'

import { IUser } from 'shared/models/User'

export const defaultTemplateAmountByPaymentType: Record<PaymentTypesType, number[]> = {
  [PaymentTypes.DEPOSIT]: [5, 20, 50, 100, 200],
  [PaymentTypes.PAYOUT]: [15, 50, 100, 150, 200],
}

export const templateAmountBySlug: Record<string, Record<PaymentTypesType, number[]>> = {
  [nowPaymentsSlug]: {
    [PaymentTypes.DEPOSIT]: [10, 25, 50, 75, 100],
    [PaymentTypes.PAYOUT]: [10, 100, 300, 700, 1000],
  },
  'flouci_card': {
    [PaymentTypes.DEPOSIT]: [40, 100, 150, 200, 300],
    [PaymentTypes.PAYOUT]: [30, 150, 250, 350, 500],
  },
  'd17_card': {
    [PaymentTypes.DEPOSIT]: [5, 50, 75, 100, 150],
    [PaymentTypes.PAYOUT]: [15, 60, 100, 150, 200],
  }
}

export const getTemplateAmountBySlug = (slug: string, type: PaymentTypesType) =>
  templateAmountBySlug?.[slug]?.[type] ?? defaultTemplateAmountByPaymentType[type]

export const replaceTemplateValue = ({ balance }: { balance?: IUser['balance'] }): Record<string, number> => ({
  $USER_BALANCE: Number(balance),
})
